// extracted by mini-css-extract-plugin
export default {"container":"CheckBoxUpgrade_container__-8ZE7","checkmark":"CheckBoxUpgrade_checkmark__BNVpO"};